import { useTranslator } from '@translator-app/react';
import classNames from 'classnames';
import React, { Children } from 'react';

import { formatCurrency } from '../../utils/currency';

export interface Props {
  totalPrice: number;
  children?: React.ReactNode | React.ReactNodeArray;
}

export const OrderLayout: React.FC<Props> = (props) => {
  let { children, totalPrice } = props;
  let { translate } = useTranslator();

  return (
    <div className="w-full">
      <div className="border-t-2">
        {Children.map(children, (child, i) => {
          return (
            <div
              className={classNames('w-full py-4', {
                'border-t': i % 2 === 1,
              })}
            >
              {child}
            </div>
          );
        })}
      </div>
      <div className="text-gray-800 text-xl flex justify-between py-2 border-t-2 font-medium">
        <div>{translate('order.total')}</div>
        <div>{formatCurrency(totalPrice)}</div>
      </div>
    </div>
  );
};
